import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import Translate from '../Translate/Translate.js';

import { ILinkConfiguration, ILinkProps, ILinkState } from './models/index.js';
import Anchor from './styledComponents/Anchor.js';
import { LINK_CATEGORY_KEY, LINK_COMPONENT_KEY } from './Link.meta.js';

export class Link extends ComponentBase<ILinkProps, ILinkState, ILinkConfiguration> {
	categoryKey = LINK_CATEGORY_KEY;
	componentKey = LINK_COMPONENT_KEY;

	constructor(props: ILinkProps) {
		super(props);
	}
	render() {
		const { children, ...anchorProps } = this.props;
		return (
			<Anchor {...anchorProps}>
				<Translate>{children}</Translate>
			</Anchor>
		);
	}
}

export default InjectedStyledComponent(observer(Link), LINK_CATEGORY_KEY, LINK_COMPONENT_KEY);
